import { PageBreak, Paragraph, TextRun, BorderStyle, HeadingLevel } from 'docx'
import SectionHeader from '../../SectionHeader'
import { parseDateToTaiwanDateSlash } from '../../../ReportPDF/TaiwanDateConvert'

const Chapter5Page = ({ reportData }) => {
  const { reprotDao, phishCampaignReport } = reportData || {}
  const { companyName, campaignStartDate, campaignEndDate } = reprotDao || {}

  const {
    userCount = 0,
    fileCount = 0,
    linkCount = 0,
    openCount = 0,
    textCount = 0,
    openPercent = 0,
    linkPercent = 0,
    filePercent = 0,
    textPercent = 0,
  } = phishCampaignReport || {}

  const formattedData = {
    userCount,
    fileCount,
    linkCount,
    openCount,
    textCount,
    openPercent: openPercent.toFixed(2),
    linkPercent: linkPercent.toFixed(2),
    filePercent: filePercent.toFixed(2),
    textPercent: textPercent.toFixed(2),
  }

  return [
    new Paragraph({ children: [new PageBreak()] }),
    new Paragraph(''),
    SectionHeader({
      text: '第五章 結論',
      size: 52,
      headingNumber: HeadingLevel.HEADING_1,
    }),
    new Paragraph({
      border: {
        top: {
          color: '#000000',
          style: BorderStyle.SINGLE,
          size: 25, // 控制橫線的粗細
        },
      },
    }),
    new Paragraph(''),
    new Paragraph({
      style: 'textParagraph',
      children: [
        new TextRun({
          text: '\t',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: '本報告之內容為完整的社交工程郵件演練服務報告，作為',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: companyName,
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: '之社交工程資訊安全評估使用，測試時程為',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: `${parseDateToTaiwanDateSlash(campaignStartDate)} 至 ${parseDateToTaiwanDateSlash(
            campaignEndDate,
          )}`,
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
          bold: true,
          underline: {}, // 加上下劃線
        }),
        new TextRun({
          text: '。為防止惡意郵件攻擊，請依照本專案測試所給予之分析報告，針對特定單位及對象再次舉行教育訓練之宣導。',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
      ],
    }),
    new Paragraph(''),
    new Paragraph({
      style: 'textParagraph',
      children: [
        new TextRun({
          text: '\t',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: '本次受測對象共',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: `${formattedData.userCount || 0}`,
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
          bold: true,
        }),
        new TextRun({
          text: '人，瀏覽測試郵件之人數為',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: `${formattedData.openCount || 0}`,
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
          bold: true,
        }),
        new TextRun({
          text: '人，占總受測人數的',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: `${formattedData.openPercent}`,
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
          bold: true,
        }),
        new TextRun({
          text: '%；開啟測試連結之人數為',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: `${formattedData.linkCount || 0}`,
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
          bold: true,
        }),
        new TextRun({
          text: '人，占總受測人數的',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: `${formattedData.linkPercent}`,
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
          bold: true,
        }),
        new TextRun({
          text: '%；點閱測試連結之人數為',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: `${formattedData.fileCount || 0}`,
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
          bold: true,
        }),
        new TextRun({
          text: '人，占總受測人數的',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: `${formattedData.filePercent}`,
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
          bold: true,
        }),
        new TextRun({
          text: '%；輸入資料之人數為',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: `${formattedData.textCount || 0}`,
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
          bold: true,
        }),
        new TextRun({
          text: '人，占總受測人數的',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: `${formattedData.textPercent}`,
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
          bold: true,
        }),
        new TextRun({
          text: '%。多數受測者具有相當警覺性，未開啟社交檢測信件，但仍有受測者未詳察寄件來源或身份，建議可針對此類受測者進行教育訓練，藉此訓練受測者自身資安意識的強化。',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
      ],
    }),
    new Paragraph(''),
    new Paragraph({
      style: 'textParagraph',
      children: [
        new TextRun({
          text: '\t',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: '針對此次檢測，',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: companyName,
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: '受測者均有相當程度之資安意識，但資訊安全之宣導及教育仍然必須持續進行，才能促使組織成員養成良好的電子郵件使用習慣。此外，亦可針對警覺性較低的受測對象(如開啟信件比率最高的某處室或某先生/小姐)，規劃二次教育訓練，加強相關防護觀念的宣導，並著重攻擊實例說明，並應按其資安等級，定期舉辦教育訓練。相關技術和規劃方式歡迎諮詢台灣固網的專業人員。',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
      ],
    }),
    new Paragraph(''),
    new Paragraph({
      style: 'textParagraph',
      children: [
        new TextRun({
          text: '\t',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: '由於資訊安全相關產業的發展非常迅速，而且社交工程攻擊總是不斷地被發現，定期舉行教育訓練與社交工程演練才能使組織安全防護達到內外相護的最佳效果，這也絕對是保障組織內部資訊安全的必要步驟。',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
      ],
    }),
  ]
}

export default Chapter5Page
